export function serialize(name: string, value: unknown): void {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage[name] = value === undefined ? undefined : JSON.stringify(value);
}

export function unserialize<T = any>(name: string, defaultValue?: T): T {
  if (typeof localStorage === 'undefined') {
    return defaultValue as T;
  }

  const value = localStorage[name] as T;

  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  return defaultValue as T;
}
